import { computed, Injectable, Injector, signal } from '@angular/core';
import {
  IntegrateLookup,
  IntegrateLookupsResponse,
  LookupApi,
} from '@via/models';

import { LookupService } from './lookup.service';

@Injectable({
  providedIn: 'root',
})
export class IntegrateLookupService extends LookupService<
  IntegrateLookupsResponse,
  IntegrateLookup
> {
  public platformFrom = computed(() => {
    if (!this.lookups().platformFrom.length) {
      // this.fetchLookupsByName('platformFrom');
    }

    return this.lookups().platformFrom;
  });
  public platformTo = computed(() => {
    if (!this.lookups().platformTo.length) {
      // this.fetchLookupsByName('platformTo');
    }

    return this.lookups().platformTo;
  });
  public transactionFrom = computed(() => {
    if (!this.lookups().from.length) {
      // this.fetchLookupsByName('from');
    }

    return this.lookups().from;
  });
  public transactionTo = computed(() => {
    if (!this.lookups().to.length) {
      // this.fetchLookupsByName('to');
    }

    return this.lookups().to;
  });
  public transactionStatuses = computed(() => {
    if (!this.lookups().statuses.length) {
      // this.fetchLookupsByName('statuses');
    }

    return this.lookups().statuses;
  });
  public transactionTypes = computed(() => {
    if (!this.lookups().transactionTypes.length) {
      // this.fetchLookupsByName('transactionTypes');
    }

    return this.lookups().transactionTypes;
  });

  constructor(private inj: Injector) {
    super(inj);

    this.lookupApi = LookupApi.Integrate;
    this.lookups = signal({
      platformFrom: [],
      platformTo: [],
      from: [],
      to: [],
      statuses: [],
      transactionTypes: [],
      valueTypeInfos: [],
    });
  }

  findLookup<T = IntegrateLookup>(
    lookupName: keyof IntegrateLookupsResponse,
    val: string | number
  ) {
    return this.lookups()[lookupName as keyof IntegrateLookupsResponse].find(
      (l) => l.id === val || l.name === val
    ) as T | undefined;
  }
}
